import actionTypes from '../common/actionTypes';
import { defaultPaymentHistory } from './paymentAPI';

interface State {
	details: any;
	payment: PaymentHistory;
	payments: PaymentHistory[];
	stripe: any;
	subscriptionResponse: any;
	chargeResponse: any;
	invoice: StripeInvoice;
	card: StripeCard;
	invoiceCard: StripeCard;
}
const initialState = {
	details: {
		amount: '',
		ccCardholderName: ''
	},
	payment: defaultPaymentHistory,
	payments: [],
	stripe: {},
	subscriptionResponse: {},
	chargeResponse: {},
	invoice: {},
	card: {},
	invoiceCard: {}
};
export default function paymentReducer(state: State = initialState, action: any) {
	switch (action.type) {
		case actionTypes.SET_STRIPE:
			return { ...state, stripe: action.stripe };
		case actionTypes.SET_PAYMENT_DETAILS:
			return { ...state, details: action.details };
		case actionTypes.CREATE_SUBSCRIPTION:
			return { ...state, subscriptionResponse: action.subscriptionResponse };
		case actionTypes.CREATE_CHARGE:
			return { ...state, chargeResponse: action.chargeResponse };
		case actionTypes.FETCH_CUSTOMER_PAYMENT:
			return { ...state, payment: action.payment };
		case actionTypes.FETCH_CUSTOMER_PAYMENTS:
			return { ...state, payments: action.payments };
		case actionTypes.FETCH_CUSTOMER_UPCOMING_INVOICE:
		case actionTypes.PAY_INVOICE:
			return { ...state, invoice: action.invoice };
		case actionTypes.FETCH_CUSTOMER_CARD:
			return { ...state, card: action.card };
		case actionTypes.FETCH_INVOICE_CARD:
			return { ...state, invoiceCard: action.invoiceCard };
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/payment/paymentReducer.ts